<template>
  <v-container
    v-if="account"
    class="page">
    <v-row>
      <v-col md="12">
        <v-tabs fixed-tabs>
          <v-tab
            v-for="(value, key) in tabs"
            :key="key"
            :value="value"
            @click="tab = value">
            {{ value }}
          </v-tab>
        </v-tabs>
        <div v-if="tab === tabs.DETAILS">
          <v-row>
            <v-col>
              <v-card
                class="mx-auto"
                outlined>
                <v-row>
                  <v-col cols="12 pb-1">
                    <div class="overline ml-4">
                      {{ account.account_type }}
                    </div>
                  </v-col>
                  <v-col cols="6 pt-1">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-3">
                          {{ account.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle class=" mb-2">
                          Adresse : {{ account.address.line1 }}
                          {{ account.address.zip_code }} {{ account.address.city }} {{ account.address.country }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Email : {{ account.email }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Téléphone : {{ account.phone }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Référent :
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          {{ account.first_admin.title }}.
                          {{ account.first_admin.last_name }} {{ account.first_admin.first_name }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          {{ account.first_admin.email }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          {{ account.first_admin.phone }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          v-if="currentBill"
                          class="mt-2">
                          Consommation actuelle
                        </v-list-item-subtitle>
                        <v-list-item>
                          <v-btn @click="downloadPdf">
                            .pdf
                          </v-btn>
                          <v-btn @click="downloadCsv">
                            .csv
                          </v-btn>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="6 pt-1">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <div class=" mb-2">
                          Informations compte:
                        </div>
                        <v-list-item-subtitle class=" mb-2">
                          pk : {{ account.pk }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Vérifié : <span />{{ account.verified | booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Siret : <span />{{ account.siret | nullLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Signature électrique :
                          {{ account.electronic_signature_enabled | booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Éspace acquereur : {{ account.buyer_space_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          MGC : {{ account.mgc_enabled | booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          EIDAS : <span />{{ account.eidas_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          ID AR24 : <span />{{ account.ar24_user_id | nullLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mb-2">
                          Site brikx : <span />{{ account.brikx_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class=" mb-2">
                          Abonnement : {{ account.plan.name }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          Créer des utilisateurs : {{ account.plan.can_add_users |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          Adv actif : {{ account.plan.adv_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          Stats actif : {{ account.plan.stats_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="ml-4 mb-2">
                          Calendrier actif : {{ account.plan.calendar_enabled |
                            booleanLabel }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mb-2">
                          <v-btn @click="goToMgc">
                            MGC
                          </v-btn>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12 pb-1">
                    <v-simple-table>
                      <template #default>
                        <thead>
                          <tr>
                            <th
                              class="ml-2 my-4">
                              {{ myRelation.length }} relation(s)
                            </th>
                          </tr>
                          <tr>
                            <th class="text-left">
                              Nom
                            </th>
                            <th class="text-left">
                              email
                            </th>
                            <th class="text-left">
                              phone
                            </th>
                            <th class="text-left">
                              pk
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="relation in myRelation"
                            :key="relation.key">
                            <td>
                              {{ relation.name }}
                            </td>
                            <td>
                              {{ relation.email }}
                            </td>
                            <td>
                              {{ relation.phone }}
                            </td>
                            <td>
                              {{ relation.pk }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div v-else-if="tab === tabs.LINES">
          <v-row>
            <v-col md="2">
              <v-card
                class="mx-auto"
                max-width="500">
                <v-list>
                  <v-list-item-group v-model="selectedYear">
                    <v-list-item
                      v-for="year in years"
                      :key="year"
                      :value="year">
                      <v-list-item-content>
                        <v-list-item-title v-text="year" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
            <v-col md="2">
              <v-card
                class="mx-auto"
                max-width="500">
                <v-list>
                  <v-list-item-group v-model="selectedMonth">
                    <v-list-item
                      v-for="month in months"
                      :key="month.value"
                      :value="month.value">
                      <v-list-item-content>
                        <v-list-item-title v-text="month.label" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
            <v-col md="8">
              <v-data-table
                disable-sort
                item-key="pk"
                :loading="isLoading"
                :headers="headers"
                :items="rows"
                :items-per-page="perPage"
                :page.sync="currentRowsPage"
                hide-default-footer
                class="elevation-1">
                <template #item.date="{ item }">
                  {{ item.date | dtFormat('DD/MM/YYYY') }}
                </template>
              </v-data-table>
              <v-pagination
                v-if="rowsPages"
                v-model="currentRowsPage"
                :length="rowsPages"
                @input="getRowItems" />
            </v-col>
          </v-row>
        </div>
        <div v-else-if="tab === tabs.BILLS">
          <v-row>
            <v-col>
              <v-data-table
                disable-sort
                item-key="pk"
                :loading="isLoading"
                :headers="headers"
                :items="bills"
                :items-per-page="perPage"
                :page.sync="currentBillsPages"
                hide-default-footer
                class="elevation-1">
                <template #item.date="{ item }">
                  {{ item.date | dtFormat('DD/MM/YYYY') }}
                </template>
                <template #item.file_path="{ item }">
                  <a
                    :href="item.file_path"
                    target="_blank">
                    <v-icon>mdi-download</v-icon>
                  </a>
                </template>
              </v-data-table>
              <v-pagination
                v-if="billsPages"
                v-model="currentBillsPages"
                :length="billsPages"
                @input="getBillItems" />
            </v-col>
          </v-row>
        </div>
        <div v-else-if="tab === tabs.DISCOUNTS">
          <v-row>
            <v-col>
              <v-data-table
                disable-sort
                item-key="pk"
                :loading="isLoading"
                :headers="headers"
                :items="discounts"
                :items-per-page="perPage"
                :page.sync="currentDiscountsPage"
                hide-default-footer
                class="elevation-1">
                <template #item.date="{ item }">
                  {{ item.date | dtFormat('DD/MM/YYYY') }}
                </template>
                <template #item.info="{ item }">
                  <v-dialog
                    v-model="dialog"
                    width="500">
                    <template #activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on">
                        {{ item.info | truncate }}
                      </span>
                    </template>
                    <v-card>
                      <v-card-text>
                        {{ item.info }}
                      </v-card-text>
                      <v-divider />
                    </v-card>
                  </v-dialog>
                </template>
                <template #item.action="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-icon
                        color="red"
                        v-on="on"
                        @click="deleteDiscount(item)">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-pagination
                v-if="discountsPages"
                v-model="currentDiscountsPage"
                :length="discountsPages"
                @input="getDiscountItems" />
              <v-btn
                v-if="billingAccount"
                color="secondary"
                fixed
                bottom
                right
                fab
                :to="{name: 'newDiscount', query: { 'accountPk': billingAccount.pk }}">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import RESOURCES from '@batimentb/vadimm-js-api/resources'

  const TABS = Object.freeze({
    DETAILS: 'Détails',
    LINES: 'Consommation',
    BILLS: 'Facture',
    DISCOUNTS: 'Réduction'
  })

  export default {
    name: 'AccountVue',
    data () {
      return {
        tabs: TABS,
        dialog: false,
        filters: {
          date__gte: moment().startOf('month').utc().toISOString(),
          date__lte: moment().endOf('month').utc().toISOString()
        },
        selectedYear: moment().format('YYYY'),
        selectedMonth: moment().format('MM'),
        isLoading: false,
        bills: [],
        billsPages: 0,
        currentBillsPages: 1,
        rowsPages: 0,
        perPage: 10,
        currentRowsPage: 1,
        discountsPages: 0,
        rows: [],
        discounts: [],
        currentDiscountsPage: 1,
        billingAccount: null,
        account: null,
        relations: [],
        tab: TABS.DETAILS,
        items: [
          { title: 'Detail' },
          { title: 'Consommation' },
          { title: 'Facture' },
          { title: 'Reduction' }
        ]
      }
    },
    computed: {
      myRelation () {
        if (this.account.account_type === 'promoteur') {
          let promoteurRelation = Object.values(this.relations).filter((x) => {
            return x.account_one.pk === this.accountPk
          })
          return promoteurRelation.map(x => {
            console.log(x)
            return x.account_two
          })
        } else {
          let commercialRelation = Object.values(this.relations).filter((x) => {
            return x.account_two.pk === this.accountPk
          })
          return commercialRelation.map(x => {
            console.log(x)
            return x.account_one
          })
        }
      },
      months () {
        return [
          { value: '01', int: 0, label: 'Janvier' },
          { value: '02', int: 1, label: 'Février' },
          { value: '03', int: 2, label: 'Mars' },
          { value: '04', int: 3, label: 'Avril' },
          { value: '05', int: 4, label: 'Mai' },
          { value: '06', int: 5, label: 'Juin' },
          { value: '07', int: 6, label: 'Juillet' },
          { value: '08', int: 7, label: 'Aout' },
          { value: '09', int: 8, label: 'Septembre' },
          { value: '10', int: 9, label: 'Octobre' },
          { value: '11', int: 10, label: 'Novembre' },
          { value: '12', int: 11, label: 'Décembre' }
        ]
      },
      years () {
        const years = []
        const dateStart = moment().year('2019')
        const dateEnd = moment()
        while (dateEnd.diff(dateStart, 'years') >= 0) {
          years.push(dateStart.format('YYYY'))
          dateStart.add(1, 'year')
        }
        return years
      },
      headers () {
        const headers = {
          [TABS.LINES]: [
            {
              text: 'Code',
              value: 'code'
            },
            {
              text: 'Prix',
              value: 'price'
            },
            {
              text: 'Date de Création',
              value: 'date'
            }
          ],
          [TABS.BILLS]: [
            {
              text: 'Référence',
              value: 'ref'
            },
            {
              text: 'Date',
              value: 'date'
            },
            {
              text: 'Lien',
              value: 'file_path'
            }
          ],
          [TABS.DISCOUNTS]: [
            {
              text: 'Date',
              value: 'date'
            },
            {
              text: 'Montant',
              value: 'value'
            },
            {
              text: 'Nom',
              value: 'name'
            },
            {
              text: 'Article',
              value: 'code'
            },
            {
              text: 'Actions',
              value: 'action',
              sortable: false
            }
          ]
        }
        return headers[this.tab]
      },
      currentBill () {
        let year = moment().format('YYYY')
        let month = moment().format('MM')
        if (this.billingAccount) {
          const billingApiUrl = process.env.VUE_APP_BILLING_API
          return `${billingApiUrl}/api/accounts/${this.billingAccount.pk}/${year}/${month}/invoice`
        }
        return null
      },
      accountPk () {
        return this.$route.params.id
      }
    },
    watch: {
      'selectedMonth' (v) {
        let month = this.months.find(a => a.value === v)
        this.filters.date__gte = moment().month(month.int).startOf('month').utc().toISOString()
        this.filters.date__lte = moment().month(month.int).endOf('month').utc().toISOString()
        this.rowsPages = 0
        this.currentRowsPage = 1
        this.getRowItems()
      },
      'selectedYear' (v) {
        this.filters.date__gte = moment().year(v).startOf('month').utc().toISOString()
        this.filters.date__lte = moment().year(v).endOf('month').utc().toISOString()
        this.rowsPages = 0
        this.currentRowsPage = 1
        this.getRowItems()
      }
    },
    created () {
      if (this.$route.params.tab) {
        this.tab = this.tabs[this.$route.params.tab]
      }
      this.getAccount()
      this.getRelation()
      this.getBillAccount()
    },
    methods: {
      goToMgc () {
        this.$router.replace({
          name: 'Mgc',
          params: { id: this.account.pk }
        })
      },
      downloadPdf () {
        let link = document.createElement('a')
        link.href = this.currentBill
        link.target = '_blank'
        link.click()
      },
      downloadCsv () {
        let link = document.createElement('a')
        link.href = `${this.currentBill}?format=csv`
        link.target = '_blank'
        link.click()
      },
      async deleteDiscount (item) {
        console.log(item)
        try {
          await this.$billingApi.delete(`/discounts/${item.pk}`)
          let idx = this.discounts.findIndex(a => a.pk === item.pk)
          this.discounts.splice(idx, 1)
        } catch (err) {
          console.log(err)
        }
      },
      async getAccount () {
        let { data } = await this.$api.getOne(RESOURCES.ACCOUNT, this.accountPk)
        this.account = Object.assign({}, data)
      },
      async getRelation () {
        let payload = {
          'account': this.accountPk
        }
        let { data } = await this.$api.get(RESOURCES.ACCOUNT_RELATION, payload)
        this.relations = Object.assign({}, data.items)
      },
      async getBillAccount () {
        const queryParams = {
          external_pk: this.accountPk
        }
        try {
          let { data } = await this.$billingApi.get(`/accounts`, { params: queryParams })
          this.billingAccount = data.items[0]
          await this.getRowItems()
          await this.getDiscountItems()
          await this.getBillItems()
        } catch (err) {
          console.log(err)
        }
      },
      async getRowItems (account) {
        this.isLoading = true
        const queryParams = {
          account: this.billingAccount.pk,
          page: this.currentRowsPage,
          per_page: this.perPage,
          ...this.filters
        }
        try {
          let { data } = await this.$billingApi.get(`/lines`, { params: queryParams })
          this.rows = data.items
          this.rowsPages = data.pages
          this.currentRowsPage = data.page
        } catch (err) {
          console.log(err)
        } finally {
          this.isLoading = false
        }
      },
      async getBillItems (account) {
        this.isLoading = true
        const queryParams = {
          account: this.billingAccount.pk,
          page: this.currentBillsPages,
          per_page: this.perPage
        }
        try {
          let { data } = await this.$billingApi.get(`/invoices`, { params: queryParams })
          this.bills = data.items
          this.billsPages = data.pages
          this.currentBillsPages = data.page
        } catch (err) {
          console.log(err)
        } finally {
          this.isLoading = false
        }
      },
      async getDiscountItems (account) {
        this.isLoading = true
        const queryParams = {
          account: this.billingAccount.pk,
          page: this.currentDiscountsPage,
          per_page: this.perPage
        }
        try {
          let { data } = await this.$billingApi.get(`/discounts`, { params: queryParams })
          this.discounts = data.items
          this.discountsPages = data.pages
          this.currentDiscountsPage = data.page
        } catch (err) {
          console.log(err)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>

<style scoped>

</style>
